import React from "react";
import CommonSelectsQuestionEdit from "./CommonSelectsQuestionEdit";

function QuestionMatrixEdit(props) {
    return (<CommonSelectsQuestionEdit {...props}/>);
}

export default QuestionMatrixEdit;